import React from 'react';
import { Modal } from './Modal';
import { RefreshCw, CheckCircle2, XCircle } from 'lucide-react';
import { PrimaryButton } from './PrimaryButton';

export const SyncModal = ({ isOpen, onClose, isSyncing, syncResult }) => {
    return (
        <Modal isOpen={isOpen} onClose={isSyncing ? undefined : onClose} width="max-w-md">
            <div className="p-6">
                <div className="flex flex-col items-center justify-center space-y-4 py-4">

                    {isSyncing ? (
                        <>
                            <div className="relative">
                                <div className="absolute inset-0 bg-blue-500 rounded-full blur-xl opacity-20 animate-pulse"></div>
                                <RefreshCw size={48} className="text-blue-400 animate-spin relative z-10" />
                            </div>
                            <h3 className="text-xl font-bold text-white text-center mt-4">Syncing to Remote Server...</h3>
                            <p className="text-stone-400 text-center text-sm">
                                Please wait while files are being transferred and the remote setup is deployed.
                                <br />This might take a minute.
                            </p>
                        </>
                    ) : syncResult ? (
                        <>
                            {syncResult.success ? (
                                <>
                                    <div className="bg-green-500/10 p-4 rounded-full border border-green-500/20 mb-2">
                                        <CheckCircle2 size={48} className="text-green-500" />
                                    </div>
                                    <h3 className="text-xl font-bold text-white text-center">Sync Complete!</h3>
                                    <p className="text-stone-300 text-center text-sm bg-stone-900 border border-stone-800 p-3 rounded-md w-full mt-2">
                                        {syncResult.message || `Successfully synced: ${syncResult.synced}`}
                                    </p>
                                </>
                            ) : (
                                <>
                                    <div className="bg-red-500/10 p-4 rounded-full border border-red-500/20 mb-2">
                                        <XCircle size={48} className="text-red-500" />
                                    </div>
                                    <h3 className="text-xl font-bold text-white text-center">Sync Failed</h3>
                                    <p className="text-red-400 text-center text-sm bg-red-950/30 border border-red-900/50 p-3 rounded-md w-full mt-2 break-words">
                                        {syncResult.message || "An unknown error occurred during sync."}
                                    </p>
                                </>
                            )}

                            <div className="w-full mt-6 flex justify-center">
                                <PrimaryButton onClick={onClose} className="w-full justify-center">
                                    Close
                                </PrimaryButton>
                            </div>
                        </>
                    ) : (
                        // Fallback state if opened without syncing and without result
                        <p className="text-stone-400">Preparing sync...</p>
                    )}
                </div>
            </div>
        </Modal>
    );
};
